<app-loader *ngIf="loading"></app-loader>
<div class="item-comments h-100">
    <div class="comment header-section d-flex align-items-center justify-content-between">
        <h5 class="m-0 ps-3">Comments</h5>
        <button 
        class="header-icon close-btn me-3" 
        (click)="close()" 
        aria-label="Close"
        >
            <i 
                class="fas fa-times" 
                title="Close Popup"
            ></i>
        </button>
    </div>
    <div class="scroll-content custom-scrollbar">
        <div class="comment">
            <div class="user-image align-items-start float-start">
                <i class="fas fa-user"></i>
            </div>
            <div class="comment-container float-start">
                <div class="user-comment comment-action-item" *ngIf="!addComment" (click)="addComment = true">
                    <div class="comment-placeholder">Write comment here...</div>
                </div>
                <div *ngIf="addComment">
                    <ejs-richtexteditor
                        #addCommentRTE
                        [iframeSettings]="{enable: false}"
                        id="mention_integration"
                        [placeholder]="placeholderText"
                        [toolbarSettings]="tools"
                        [insertImageSettings]='insertImageSettings' 
                        (actionBegin)="onActionBegin($event)"
                        (imageUploading)="onImageUploading($event)"
                        (focus)="onAddCommentRTEFocus()"
                        (blur)="onAddCommentRTEBlur()"
                    >
                </ejs-richtexteditor>
                    <ejs-mention class="ejs-mention" [dataSource]="mentionUsers" target="#mention_integration_rte-edit-view" [fields]="{ text: 'name', value: 'email' }" [showMentionChar]="true" [allowSpaces]="true"
                        [suggestionCount]="mentionUsers.length"
                        popupWidth="250px" popupHeight="200px">
                        <ng-template #itemTemplate let-data>
                            <table>
                                <tr>
                                    <td class="mentionNameList"> <!-- List appears when you enter @ character when adding new comment -->
                                        @if(data?.name === 'Everyone') {
                                                 <span class="mentionName">{{data.name}}&nbsp;<i class="fa-solid fa-circle-info" style="color: red;" title="{{data.listOfTaggedUsers}}" (click)="$event?.stopPropagation()"></i></span>
                                             }
                                             @else {
                                                 <span class="mentionName">{{data.name}}</span>
                                             }
                                    </td>
                                </tr>
                            </table>
                        </ng-template>
                        <ng-template #displayTemplate let-data>   <!-- New Comment in add comment -->
                            @if(data?.name === 'Everyone') {
                                <a class="mentionedName" href="mailto:{{data.email}}" title="{{data.listOfTaggedUsers}}" >{{data.name}}&nbsp;<i class="fa-solid fa-circle-info" style="color: red; pointer-events: all;" title="{{data.listOfTaggedUsers}}"></i></a>
                            } @else {
                                <a class="mentionedName" href="mailto:{{data.email}}">{{data.name}}</a>
                            }
                        </ng-template>
                    </ejs-mention>
                    <div style="display: flex;" class="comment-buttons text-end mt-1">
                        <ng-container *ngIf="isIscModule && showIsPrivateCheckBox">
                            <ejs-checkbox  [(ngModel)]="isPrivate" style="flex: 1" label="Mark as Private"></ejs-checkbox>
                        </ng-container>
                        <!-- <div style="flex: 3">
                            <button class="btn btn-sm btn-danger me-2 comment-action-item" (click)="onCancel(addCommentRTE)">Cancel</button>
                            <button type="button" (click)="saveComment(addCommentRTE)" class="btn btn-sm btn-success comment-action-item">
                                Save
                            </button>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>
        <div class="comment" *ngFor="let comment of comments">
            <div *ngIf="!comment.isDeleted">
                <div class="user-image align-items-start float-start">
                    <i *ngIf="!comment.imagePath" class="fas fa-user"></i>
                    <img *ngIf="comment.imagePath" [src]="comment.imagePath" alt="user image" />
                </div>
                <div class="comment-container float-start">
                    <div *ngIf="comment.beingEdited">
                        <ejs-richtexteditor 
                            #commentRTE 
                            [id]="'mention_integration_edit_' + comment.commentId"
                            [value]="comment.comment" [iframeSettings]="{enable: false}"
                            [placeholder]="placeholderText"
                            [toolbarSettings]="tools" 
                            [insertImageSettings]='insertImageSettings' 
                            (dialogOpen)="commentRTE.refreshUI()"
                            (actionComplete)="onActionComplete($event, commentRTE)"
                            (focus)="onEditCommentRTEFocus(comment.commentId)"
                            (blur)="onEditCommentRTEBlur(comment.commentId)"
                        >
                        </ejs-richtexteditor>
                        <ejs-mention class="ejs-mention" [dataSource]="mentionUsers" [target]="'#mention_integration_edit_' + comment.commentId + '_rte-edit-view'" [fields]="{ text: 'name', value: 'email' }" [showMentionChar]="true" [allowSpaces]="true"
                            [suggestionCount]="mentionUsers.length"
                            popupWidth="250px" popupHeight="200px">
                            <ng-template #itemTemplate let-data>
                                <table>
                                    <tr>
                                        <td class="mentionNameList"> <!-- List appears when you enter @ character when Editting a comment -->
                                             @if(data?.name === 'Everyone') {
                                                 <span class="mentionName">{{data.name}}&nbsp;<i class="fa-solid fa-circle-info" style="color: red;" title="{{data.listOfTaggedUsers}}"></i></span>
                                             }
                                             @else {
                                                 <span class="mentionName">{{data.name}}</span>
                                             }
                                        </td>
                                    </tr>
                                </table>
                            </ng-template>
                            <ng-template #displayTemplate let-data>    <!-- Updated comment after editting comment -->
                            @if(data?.name === 'Everyone') {
                                <a class="mentionedName" href="mailto:{{data.email}}" title="{{data.listOfTaggedUsers}}">{{data.name}}&nbsp;<i class="fa-solid fa-circle-info" style="color: red; pointer-events: all;" title="{{data.listOfTaggedUsers}}"></i></a>
                            } @else {
                                <a class="mentionedName" href="mailto:{{data.email}}" title="{{data.name}}">{{data.name}}</a>
                            }
                            </ng-template>
                        </ejs-mention>
                        <div style="display: flex;" class="comment-buttons text-end mt-1">
                            <ng-container *ngIf="isIscModule && showIsPrivateCheckBox">
                                <ejs-checkbox style="flex: 1" [(ngModel)]="comment.isPrivate" label="Mark as Private"></ejs-checkbox>
                            </ng-container>
                            <div style="flex: 3">
                                <button class="btn btn-sm btn-danger me-2 comment-action-item" (click)="comment.beingEdited = false">Cancel</button>
                                <button class="btn btn-sm btn-success comment-action-item" (click)="updateComment(comment,commentRTE)">Update</button>
                            </div>
                        </div>
                    </div>
                    <div class="user-comment position-relative" *ngIf="!comment.beingEdited">
                        <div class="comment-action-buttons position-absolute right-0 top-0"  *ngIf="comment.canEdit">
                            <ng-container *ngIf="isIscModule && showIsPrivateCheckBox">
                            <a class="me-2 comment-action-item isPrivate-btn" href="javascript:" *ngIf="comment.isPrivate" title="Is Private"><i class="fas fa-eye-slash comment-action-item"></i></a>
                            <a class="me-2 comment-action-item isPrivate-btn" href="javascript:" *ngIf="!comment.isPrivate" title="Is Not Private"><i class="fas fa-eye comment-action-item"></i></a>
                            </ng-container>
                        
                            <a class="me-2 comment-action-item edit-btn" href="javascript:" (click)="comment.beingEdited = true" title="Edit Comment"><i class="fas fa-pencil-alt comment-action-item"></i></a>
                            <a class="me-2 comment-action-item copy-btn" href="javascript:" (click)="copyComment(comment.comment)" title="Copy Comment"><i class="fas fa-copy comment-action-item"></i></a>
                            <a class="comment-action-item delete-btn" href="javascript:" (click)="deleteComment(comment.commentId)" title="Delete Comment"><i class="fas fa-trash comment-action-item"></i></a>
                        </div>
                        <div class="d-flex align-items-center mb-1">
                            <div class="user-name">{{ comment.displayName }}</div>
                            <div class="comment-date" title="{{ comment.commentDateTime | date: 'MMM d, y, h:mm' }}">{{ comment.commentDateTime | dateAgo }}</div>
                        </div>
                        <div class="custom-scrollbar comments" [innerHTML]="sanitizedComment(comment.comment)"></div>
                    </div>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
    </div>
    <div class="dialog-footer">    
        <div class="right-actions">
            <button type="button" class="btn btn-sm btn-danger" (click)="close()"> Close </button>
            <button type="button" class="btn btn-sm btn-success comment-action-item" (click)="saveComment(addCommentRTE, false )">
            Post Comment
            </button>

            <button type="button" class="btn btn-sm btn-success comment-action-item" (click)="saveComment(addCommentRTE, true)">
            Post & Close
            </button>
        </div>
    </div>
</div>
